import { render, staticRenderFns } from "./VarientTags.vue?vue&type=template&id=52b5f86d"
import script from "./VarientTags.vue?vue&type=script&lang=js"
export * from "./VarientTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports